import styled from "styled-components";
import { Trans } from "@coworker/locales";
import BasicWidget from "@coworker/components/src/components/BasicWidget";
import { useInputPopup } from "../../InputPopup";
import InformationCircle from "../../../assets/svg/information-circle.svg?react";
import trackerHelper from "../../../helpers/tracker";

const Blue = styled("div")`
  color: var(--new);
`;

export default function LearnAboutSafetyAlarm() {
  const { getInput } = useInputPopup();
  return (
    <div
      onClick={() => {
        trackerHelper.safetyAlarmInfo.open();
        getInput("infoAboutSafetyAlarm", {
          title: <Trans>safetyAlarmString</Trans>,
        }).then((x) => {
          if (x === undefined) trackerHelper.safetyAlarmInfo.closeX();
        });
      }}
    >
      <BasicWidget
        icon={<InformationCircle color="var(--new)" />}
        title={
          <Blue>
            <Trans>safetyAlarmLearnMoreString</Trans>
          </Blue>
        }
      />
    </div>
  );
}
